import {
	ChangeDetectionStrategy,
	Component
} from '@angular/core';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';

@Component({
	selector: 'archive-breadcrumbs',
	templateUrl: './archive-breadcrumbs.component.html',
	styleUrls: ['./archive-breadcrumbs.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})

export class ArchiveBreadCrumbsComponent {
	constructor (
		private routerService: RouterService
	) {}

	public goToArchive = () => {
		this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_ARCHIVE);
	};
}
